import React from 'react';
import Reflux from 'reflux';
import {Button, Row, Col, Modal, Select, Input, message, Tag} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView} from '../../components';
import {openNotice} from 'Utils';
import {
    getGouXiaoUnitList,
    getSpecialOrderDetail,
    getSpecialList,
    saveSpecialOrder,
    getItemList, getSpecialDetail,
    giveTeJia2, giveTeJia, getContract, getSpecialType
} from '../../service/specialOrder';
import moment from "moment";

class SpecialOrderAdd extends Reflux.Component {
    constructor(props) {
        super(props);
        this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
        this.state = {
            channelCode: this.channelData.split('|')[1] || '',
            opts: ['特殊订单'],
            selectedRowsAllKeys: [],
            selectedRowKeys: [],
            dataSource: [],
            gouxiaoUnitList: [],
            rows: [],
            addRows4: [],
            addRows5: [],
            addRows6: [],
            rowsOutSide: [],
            total: 1,
            dataSourceTotal: 1,
            addTotal4: 1,
            addTotal5: 1,
            addTotal6: 1,
            userName: JSON.parse(window.localStorage.getItem('login_user_information')).userName,
            searchObj: {
                s: 10,
                p: 1
            },
            addSearchObj: {
                s: 10,
                p: 1,
                productCode: '',
                proMiddleName: ''
            },
            addSearchObj4: {
                s: 5,
                p: 1
            },
            addSearchObj5: {
                s: 5,
                p: 1
            },
            addSearchObj6: {
                s: 5,
                p: 1
            },
            detail: [],
            tjlist: [],
            getTjList: [],
            visible: false,
            visible2: false,
            visible3: false,
            loading: false,
            specialOffer: '',
            lastsearch: '',
            specialCode: '',
            selectedRowKeys4: [],
            selectedRowKeys6: [],
            contractOrderName: '',
            contractId: '',
            remark: '',
            allAmount: '',
            settleOrder: '',
            specialTypeList: [],
            loading2: false,
            submitParam: {
                id: '',
                custId: JSON.parse(window.localStorage.getItem('login_user_information')).channelId,
                salesUnitId: '',
                lineList: '',
                salesChannelCode: this.channelData.split('|')[1] || '',
                orderNumber: '',
                specialCode: '',
                specialType: ''
            }
        };
        this.pageChange = this.pageChange.bind(this);
        this.addPageChange = this.addPageChange.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onOutsideSelectChange = this.onOutsideSelectChange.bind(this);
        this.remarkChange = this.remarkChange.bind(this);
        this.settleOrderChange = this.settleOrderChange.bind(this);
        this.getSpecialTypeList = this.getSpecialTypeList.bind(this);
    };

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    };

    goBack() {
        hashHistory.goBack();
    };

    /* 筛选确认 */
    advanceSubmit(form) {
        let self = this;
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                p: 1
            }
        });
    };

    /*删除*/
    deleteChange() {
        if (this.state.rowsOutSide.length === 0) {
            openNotice('warning', '请选择产品');
            return;
        }
        const ds = [...this.state.rows];
        const arr = ds.filter(item => !this.state.rowsOutSide.includes(item.itemNum));
        const selected = [];
        arr.forEach(item => {
            selected.push(item.itemNum)
        });
        this.setState({rows: arr, selectedRowsAllKeys: [...selected]}, () => {
            let allAmount = 0;
            const rows2 = this.state.rows;
            rows2.forEach(item => {
                allAmount = allAmount + item.amount || 0;
            })
            this.setState({allAmount: allAmount});
        });
    };

    pageChange(page, pageSize) {
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}});
    }

    addPageChange(page, pageSize) {
        this.setState({addSearchObj: {...this.state.addSearchObj, s: pageSize, p: page}}, () => {
            this.getAddArray();
        });
    }

    /*
     列表选择改变事件
     */
    onOutsideSelectChange = (selectedRowKeys, selectedRows) => {
        this.setState({rowsOutSide: selectedRowKeys});
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
    }

    componentWillMount() {
        let self = this;
        let channelCode = this.state.channelCode;
        this.getSpecialTypeList();
        getGouXiaoUnitList({channelCode: channelCode, s: 999}).then(res => { //购货单位
            if (res.status) {
                const data = res.data || [];
                let arr = [];
                for (let i = 0; i < data.length; i++) {
                    let x = data[i];
                    arr.push({
                        text: x.name,
                        value: x.id.toString()
                    })
                }
                if (data.length == 1) {
                    this.state.detail.salesUnitId = res.data[0].id.toString();
                    this.state.submitParam.salesUnitId = res.data[0].id.toString();
                }
                self.setState({gouxiaoUnitList: arr}, () => {
                    const id = this.props.params.id;
                    if (id) {
                        this.getDetail(id);
                    }
                })
            }
        });
    }

    componentDidMount() {
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    addlist() {
        let self = this;
        if (self.state.submitParam.specialType == '' || self.state.addSearchObj.proMiddleName == '') {
            openNotice('warning', '请先选择订单类型');
            return;
        }
        let obj = self.state.addSearchObj;
        self.setState({visible: true});
        getItemList(obj).then(res => {
            if (res.code === 200) {
                const data = res.data;
                this.setState({
                    dataSource: data,
                    dataSourceTotal: res.total
                });
            }
        });
    }

    getSpecialTypeList() {
        getSpecialType().then(res => {
            if (res.code === 200) {
                const data = res.data || [];
                let arr = [];
                for (let i = 0; i < data.length; i++) {
                    let x = data[i];
                    arr.push({
                        text: x.name,
                        value: x.sKey
                    })
                }
                this.setState({specialTypeList: arr});
            }
        })
    }

    getDetail(id) {
        getSpecialOrderDetail(id).then(res => {
            if (res.code === 200) {
                const data = res.data;
                let allAmount = 0;
                let arr = [];
                data.lineList.forEach(itm => {
                    itm.amount = itm.quantity * itm.price;
                    allAmount = allAmount + itm.quantity * itm.price;
                })

                this.setState({
                    detail: data,
                    rows: data.lineList,
                    allAmount: allAmount,
                    submitParam: {
                        ...this.state.submitParam,
                        custId: data.custId,
                        salesUnitId: data.salesUnitId.toString(),
                        orderNumber: data.orderNumber,
                        specialCode: data.specialCode,
                        specialType: data.specialType
                    },
                    addSearchObj: {
                        ...this.state.addSearchObj,
                        proMiddleName: data.specialType
                    },
                    contractOrderName: data.contractOrderName,
                    contractId: data.contractId,
                    remark: data.remark,
                    settleOrder: data.settleOrder
                });
                if (data.lineList) {
                    data.lineList.forEach(line => {
                        arr.push(line.itemNum);
                    })
                }

                if (data.specialCode != null) {
                    for (var i = 0; i < data.lineList.length; i++) {
                        this.gettejia2(data.lineList[i].inventoryItemId, data.specialCode);
                    }
                    giveTeJia2(this.state.getTjList).then(result => {
                        if (result.code == 200 && result.data) {
                            this.setState({tjlist: result.data}, () => {
                                this.tick();
                            });
                        }
                    });
                }

                this.setState({selectedRowsAllKeys: arr});
            }
        });
    }

    onSelectChangeSpecialType = (item) => {
        this.state.submitParam.specialType = item;
        this.state.addSearchObj.proMiddleName = item;
        this.setState({
            submitParam: {...this.state.submitParam},
            addSearchObj: {...this.state.addSearchObj},
            rows: []
        });
    }

    onSelectChangeGouHuoUnit = (item) => {
        this.state.submitParam.salesUnitId = item;
        this.state.detail.salesUnitId = item;
        this.state.submitParam.specialCode = '';
        const rows = this.state.rows;

        for (let i = 0; i < rows.length; i++) {
            rows[i].offerLineId = '';
            rows[i].specialFlag = 0;
        }

        this.setState({
            submitParam: {...this.state.submitParam},
            detail: {...this.state.detail},
            rows: rows,
            selectedRowKeys4: [],
            contractOrderName: '',
            contractId: '',
            selectedRowKeys6: []
        });
    }

    // 点击提交按钮
    submitHandle(type) {
        const id = this.props.params.id;
        var self = this;
        self.setState({subDisabled: true});
        let rowsData = this.state.rows;
        let rowList = [];
        for (let i = 0; i < rowsData.length; i++) {
            if (!rowsData[i].price || !rowsData[i].quantity) {
                openNotice('warning', '数量或单价不能为空！');
                self.setState({subDisabled: false});
                return;
            } else {
                let row = {};
                row.itemNum = rowsData[i].itemNum;
                row.itemDesc = rowsData[i].itemDesc;
                row.inventoryItemId = rowsData[i].inventoryItemId;
                row.quantity = rowsData[i].quantity;
                row.price = rowsData[i].price;
                row.offerLineId = rowsData[i].offerLineId;
                rowList.push(row);
            }
        }
        if (this.state.submitParam.salesUnitId == '') {
            openNotice('warning', '请选择购货单位！');
            self.setState({subDisabled: false});
            return;
        }
        if (this.state.submitParam.specialType == '') {
            openNotice('warning', '请选择订单类型！');
            self.setState({subDisabled: false});
            return;
        }
        let data = this.state.submitParam;
        if (id) {
            data.id = id;
        }
        data.submitType = type;
        data.lineList = rowList;
        data.contractOrderName = self.state.contractOrderName;
        data.contractId = self.state.contractId;
        data.remark = self.state.remark;
        data.settleOrder = self.state.settleOrder;

        saveSpecialOrder(data).then((result) => {
            if (result && result.code == 200) {
                if (data.submitType == "commit") {
                    hashHistory.goBack();
                    message.info("提交成功");
                } else {
                    message.info("保存成功");
                    const submitParam = self.state.submitParam;
                    submitParam.id = result.data.id;
                    submitParam.orderNumber = result.data.orderNumber;
                    self.setState({submitParam: submitParam});
                }
                self.setState({subDisabled: false});
            } else {
                message.error(result.message);
                self.setState({subDisabled: false});
            }
        });
    };


    handleOk = () => {
        this.setState({visible: false});
    }

    handleCancel = () => {
        this.setState({visible: false});
    }

    onChange = (e) => {
        this.setState({
            value: e.target.value
        });
    }

    addSave(record) {
        const {rows, selectedRowsAllKeys} = this.state;
        if (selectedRowsAllKeys.includes(record.itemNum)) {
            openNotice('warning', '物料已添加');
            return
        }
        record.inventoryItemId = record.id;

        if (this.state.submitParam.salesUnitId == '') {
            openNotice('warning', '请先选择购货单位');
            return
        }

        giveTeJia({
            customerId: this.state.submitParam.custId,
            proId: record.id,
            purchaseId: this.state.submitParam.salesUnitId,
            channelCode: this.state.submitParam.salesChannelCode,
            flowCode: this.state.submitParam.specialCode
        }).then(result => {
            record.offerLineId = result.data.offerLineId;
            record.price = result.data.terminalUnitPrice;
            if (result.data.terminalPriceRate == '' && result.data.terminalUnitPrice == '') {
                record.specialFlag = 0;
            } else {
                record.specialFlag = 1;
            }
            this.setState({
                rows: [...rows, record]
            })
        })
        this.setState({
            rows: [...rows, record],
            selectedRowsAllKeys: [...selectedRowsAllKeys, record.itemNum]
        })
    }

    priceChange = (record, index, e) => {
        if (e.target.value < 0) {
            openNotice('error', '价格不能为负数！', '');
            e.target.value = 0;
            return;
        } else {
            let rows = this.state.rows;
            rows[index].price = e.target.value;
            rows[index].amount = (rows[index].quantity || 0) * e.target.value;
            this.setState({rows: rows}, () => {
                let allAmount = 0;
                const rows2 = this.state.rows;
                rows2.forEach(item => {
                    allAmount = allAmount + (item.amount || 0);
                })
                this.setState({allAmount: allAmount});
            });
        }
    }

    quantityChange = (record, index, e) => {
        if (e.target.value < 0) {
            openNotice('error', '数量不能为负数！', '');
            e.target.value = 0;
            return;
        } else {
            let rows = this.state.rows;
            rows[index].quantity = e.target.value;
            rows[index].amount = (rows[index].price || 0) * e.target.value;
            this.setState({rows: rows}, () => {
                let allAmount = 0;
                const rows2 = this.state.rows;
                rows2.forEach(item => {
                    allAmount = allAmount + (item.amount || 0);
                })
                this.setState({allAmount: allAmount});
            });
        }
    }

    handleCancel6 = () => {
        this.setState({visible2: false});
    }

    handleCancel5 = () => {
        this.setState({visible3: false});
    }

    addSaveHandler4 = () => {
        if (this.state.selectedRowKeys4.length === 0) {
            openNotice('warning', '请选择至少一条列表数据');
            return;
        }
        this.setState({visible2: false});
    }

    addSaveHandler6 = () => {
        if (this.state.selectedRowKeys6.length === 0) {
            openNotice('warning', '请选择至少一条列表数据');
            return;
        }
        this.setState({visible3: false});
    }

    onSelectChange4 = (selectedRowKeys, selectedRows) => {
        this.setState({
            selectedRowKeys4: selectedRowKeys,
        })
    };

    addPageChange4 = (page, pageSize) => {
        const self = this;
        self.setState({addRows4: []});
        self.setState({addSearchObj4: {...this.state.addSearchObj4, s: pageSize, p: page}}, function () {
            self.getSepcialList();
        });
    };

    onSelectRadio4 = (record, selected, selectedRows) => {

        const submitParam = this.state.submitParam;
        submitParam.specialCode = record.specCode;

        this.setState({
            submitParam: submitParam,
            loading2: true
        });

        if (record.specCode != this.state.lastsearch) {
            this.state.addSearchObj5.p = 1;
            this.state.lastsearch = record.specCode;
        }

        //翻页的方法
        getSpecialDetail({
            specCode: record.specCode,
            p: this.state.addSearchObj5.p,
            s: this.state.addSearchObj5.s
        }).then(result => {
            if (result.status && result.code == 200) {
                var data = result.data;
                for (var i = 0; i < result.data.length; i++) {
                    result.data[i].id = i + 1;
                }
                this.setState({
                    addRows5: data,
                    addTotal5: result.total,
                    loading2: false
                });
            } else {
                this.setState({
                    loading2: false
                });
                message.error(result.message);
            }
        })

        var submitRows = [...this.state.rows];
        var tjlist = [];
        for (var i = 0; i < submitRows.length; i++) {
            const promise = this.gettejia(submitRows[i].inventoryItemId, record.specCode);
            promise.then(result => {
                tjlist.push(result.data);
                this.setState({...this.state.tjlist, tjlist}, () => {
                    this.interval = setInterval(() => this.tick(), 3000);
                });
            })
        }
    }

    getSpecialDetail = () => {
        this.setState({loading2: true});
        getSpecialDetail({
            specCode: this.state.submitParam.specialCode,
            p: this.state.addSearchObj5.p,
            s: this.state.addSearchObj5.s
        }).then(result => {
            if (result.status && result.code == 200) {
                var data = result.data;
                for (var i = 0; i < result.data.length; i++) {
                    result.data[i].id = i + 1;
                }
                this.setState({
                    addRows5: data,
                    addTotal5: result.total,
                    loading2: false
                });
            } else {
                this.setState({
                    loading2: false
                });
                message.error(result.message);
            }
        })
    }

    tick = () => {
        clearInterval(this.interval);
        var submitRows = [...this.state.rows];
        var tjlist = [...this.state.tjlist];
        submitRows.map(item => {
            tjlist.map(itm => {
                if (item.itemNum == itm.proCode) {
                    if (itm.terminalUnitPrice == '') {
                        item.specialFlag = 0;
                    } else {
                        item.specialFlag = 1;
                        item.price = itm.terminalUnitPrice;
                    }
                    item.offerLineId = itm.offerLineId;
                }
            })
        })
        this.setState({...this.state.rows, submitRows});
    }

    async gettejia(productId, specCode) {
        const result = await giveTeJia({
            customerId: this.state.submitParam.custId,
            proId: productId,
            purchaseId: this.state.detail.salesUnitId,
            channelCode: this.state.submitParam.salesChannelCode,
            flowCode: specCode,
        })
        return result;
    }

    gettejia2(productId, specCode) {
        const getTjList = [...this.state.getTjList];
        getTjList.push({
            customerId: this.state.submitParam.custId,
            proId: productId,
            purchaseId: this.state.detail.salesUnitId,
            channelCode: this.state.submitParam.salesChannelCode,
            flowCode: specCode,
        });
        this.setState({getTjList});
    }

    addPageChange5 = (page, pageSize) => {
        this.setState({addRows5: []});
        this.setState({addSearchObj5: {...this.state.addSearchObj5, s: pageSize, p: page}}, function () {
            this.getSpecialDetail();
        });
    };

    addPageChange6 = (page, pageSize) => {
        this.setState({addRows6: []});
        this.setState({addSearchObj6: {...this.state.addSearchObj6, s: pageSize, p: page}}, function () {
            this.getContract();
        });
    };

    onSelectChange6 = (selectedRowKeys, selectedRows) => {
        this.setState({
            selectedRowKeys6: selectedRowKeys
        })
    };

    onSelectRadio6 = (record, selected, selectedRows) => {
        this.setState({
            contractOrderCode: record.contractOrderCode,
            contractOrderName: record.contractOrderName,
            contractId: record.contractId,
            guaranteeQuality: record.guaranteeQuality,
        })
    }

    specialOpen = () => {
        const self = this;
        if (self.state.submitParam.salesUnitId == '') {
            openNotice('warning', '请先选择购货单位');
            return;
        }
        self.setState({visible2: true});
        self.getSepcialList();
    }

    getSepcialList = () => {
        if (this.state.specCode != this.state.lastsearch) {
            this.state.addSearchObj4.p = 1;
            this.state.lastsearch = this.state.specCode;
        }
        getSpecialList({
            projectName: this.state.projectName,
            specCode: this.state.specCode,
            buyCompanyId: this.state.detail.salesUnitId,
            userName: this.state.user,
            channelCode: this.state.submitParam.salesChannelCode,
            p: this.state.addSearchObj4.p,
            s: this.state.addSearchObj4.s
        }).then(result => {
            if (result.status && result.code == 200) {
                var data = result.data;
                for (var i = 0; i < result.data.length; i++) {
                    result.data[i].id = i + 1;
                }
                this.setState({
                    addRows4: data,
                    addTotal4: result.total,
                });
            } else {
                message.error(result.message);
            }
        })
    };

    remarkChange = (event) => {
        this.setState({
            remark: event.target.value
        });
    };

    settleOrderChange = (event) => {
        this.setState({
            settleOrder: event.target.value
        });
    };

    specialParam1 = (event) => {
        this.setState({
            specCode: event.target.value
        });
    };

    specialParam2 = (event) => {
        this.setState({
            projectName: event.target.value
        });
    };

    specialParam3 = (event) => {
        this.setState({
            user: event.target.value
        });
    };

    openAdd = (proCode) => {
        const addSearchObj = this.state.addSearchObj;
        addSearchObj.productCode = proCode;
        this.setState({visible: true, addSearchObj: addSearchObj}, () => {
            this.addlist()
        });
    }

    contractOpen = () => {
        const self = this;
        if (self.state.submitParam.salesUnitId == '') {
            openNotice('warning', '请先选择购货单位');
            return;
        }
        this.setState({visible3: true})
        this.getContract();
    }

    contractOrderCodeChange = (event) => {
        this.setState({
            contractOrderCode: event.target.value
        });
    };

    contractOrderNameChange = (event) => {
        this.setState({
            contractOrderName2: event.target.value
        });
    };

    getContract = () => {
        getContract({
            purchaseId: this.state.detail.salesUnitId,
            channelCode: this.state.submitParam.salesChannelCode,
            p: this.state.addSearchObj6.p,
            s: this.state.addSearchObj6.s,
            contractOrderName: this.state.contractOrderName2 || '',
            contractOrderCode: this.state.contractOrderCode || ''
        }).then(result => {
            if (result.status && result.code == 200) {
                var data = result.data;
                for (var i = 0; i < result.data.length; i++) {
                    result.data[i].id = i + 1;
                }
                this.setState({
                    addRows6: data,
                    addTotal6: result.total,
                });
            } else {
                message.error(result.message);
            }
        })

    }

    nameChange = (event) => {
        const addSearchObj = this.state.addSearchObj;
        addSearchObj.productCode = event.target.value;
        this.setState({
            addSearchObj: addSearchObj
        });
    };

    keypress = (e) => {
        if (e.which == 13) {
            this.addlist();
        }
    }

    render() {
        const {
            opts,
            rows,
            rowsOutSide,
            dataSource,
            dataSourceTotal,
            gouxiaoUnitList,
            total,
            searchObj,
            detail,
            addSearchObj,
            visible,
            loading,
            submitParam,
            visible2,
            visible3,
            addTotal4,
            addSearchObj4,
            addRows4,
            selectedRowKeys4,
            addTotal5,
            addSearchObj5,
            addRows5,
            addSearchObj6,
            addTotal6,
            addRows6,
            selectedRowKeys6,
            specialTypeList,
            loading2,
            allAmount
        } = this.state;
        const tableViewProps = {
            loading: false,//更新表格数据中
            rowKey: 'itemNum',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '物料编码',
                    dataIndex: 'itemNum',
                    render: (text, record, index) => {
                        return (
                            <div>
                                <span>{text}</span>
                                {!record.specialFlag ?
                                    <Tag color="red" style={{float: 'right', cursor: 'default'}}>无特价</Tag> : null}
                            </div>
                        )
                    }
                },
                {
                    title: '物料描述',
                    dataIndex: 'itemDesc'
                },
                {
                    title: '数量',
                    dataIndex: 'quantity',
                    render: (text, record, index) => {
                        return (<Input type='number' style={{width: 100}} value={record.quantity}
                                       onChange={this.quantityChange.bind(this, record, index)}/>)
                    }
                },
                {
                    title: '单价',
                    dataIndex: 'price',
                    render: (text, record, index) => {
                        return (<Input type='number' style={{width: 100}} value={record.price}
                                       onChange={this.priceChange.bind(this, record, index)}/>)
                    }
                },
                {
                    title: '金额',
                    dataIndex: 'amount'
                }
            ],
            rows,
            rowSelection: {
                selectedRowKeys: rowsOutSide,
                onChange: this.onOutsideSelectChange
            }
        };

        const addProps4 = {
            rowKey: 'id',
            loading: false,
            pageParam: {
                total: addTotal4,
                current: addSearchObj4.p,//当前页码
                pageSize: addSearchObj4.s,//当前分页数
                onChange: this.addPageChange4
            },
            columns: [
                {
                    title: '流程编码',
                    dataIndex: 'specCode',
                    width: 100
                },
                {
                    title: '项目报备名称',
                    dataIndex: 'projectName',
                    width: 100,
                },
                {
                    title: '开始日期',
                    dataIndex: 'startDate',
                    width: 100,
                    render: text => new Date(text).format('yyyy-MM-dd')
                },
                {
                    title: '结束日期',
                    dataIndex: 'endDate',
                    width: 100,
                    render: text => new Date(text).format('yyyy-MM-dd')
                },
                {
                    title: '承接业务员',
                    dataIndex: 'userName',
                    width: 100,
                },
                {
                    title: '拉动业务员',
                    dataIndex: 'pullName',
                    width: 100,
                },
                {
                    title: '拉动渠道',
                    dataIndex: 'pullChannel',
                    width: 100,
                }
            ],
            rows: addRows4,
            rowSelection: {
                selectedRowKeys: selectedRowKeys4,
                onChange: this.onSelectChange4,
                onSelect: this.onSelectRadio4,
                type: 'radio',
            }
        };
        const addProps5 = {
            rowKey: 'id',
            loading: loading2,
            pageParam: {
                total: addTotal5,
                current: addSearchObj5.p,//当前页码
                pageSize: addSearchObj5.s,//当前分页数
                onChange: this.addPageChange5
            },
            columns: [
                {
                    title: '具体物料规格',
                    children: [{
                        title: '对应物料编码',
                        dataIndex: 'proCode',
                        width: 100
                    },
                        {
                            title: '具体物料描述',
                            dataIndex: 'proDesc',
                            width: 100,
                        },
                        {
                            title: '产品数量',
                            dataIndex: 'count',
                            width: 100,
                        },
                        {
                            title: '面价',
                            dataIndex: 'listPrice',
                            width: 100,
                        },
                        {
                            title: '合同价',
                            dataIndex: 'price',
                            width: 100,
                        }, {
                            title: '预计销量(万元)',
                            dataIndex: 'amount',
                            width: 100,
                        }, {
                            title: '操作',
                            dataIndex: '',
                            width: 100,
                            render: (text, record, index) => {
                                if (record.proCode != "" && record.proCode != null) {
                                    return (<Button style={{background: '#red'}} icon="plus"
                                                    onClick={this.openAdd.bind(this, record.proCode)}>添加</Button>)
                                }
                            }
                        }]
                },
                {
                    title: '整体框架协议',
                    children: [{
                        title: '产品类别',
                        dataIndex: 'categoryDesc',
                        width: 100,
                    },
                        {
                            title: '类别编码',
                            dataIndex: 'categoryCode',
                            width: 100,
                        },
                        {
                            title: '合同下浮比例',
                            dataIndex: 'lowerRate',
                            width: 100,
                        }]
                }
            ],
            rows: addRows5,
        };

        const addProps = {
            rowKey: 'itemNum',
            loading: loading,//更新表格数据中
            pageParam: {
                total: dataSourceTotal,
                current: addSearchObj.p,//当前页码
                pageSize: addSearchObj.s,//当前分页数
                onChange: this.addPageChange
            },
            columns: [
                {
                    title: '物料编码',
                    dataIndex: 'itemNum'
                }, {
                    title: '物料名称',
                    dataIndex: 'itemDesc'
                }, {
                    title: '操作',
                    dataIndex: 'save',
                    width: 100,
                    render: (text, record, index) => (
                        <Button style={{background: '#red'}} icon="plus"
                                onClick={this.addSave.bind(this, record)}>添加</Button>)
                }],
            rows: dataSource
        }

        const addProps6 = {
            rowKey: 'RN',
            loading: false,
            pageParam: {
                total: addTotal6,
                current: addSearchObj6.p,//当前页码
                pageSize: addSearchObj6.s,//当前分页数
                onChange: this.addPageChange6
            },
            columns: [
                {
                    title: '合同编号',
                    dataIndex: 'contractOrderCode',
                    width: 100
                },
                {
                    title: '合同名称',
                    dataIndex: 'contractOrderName',
                    width: 100,
                },
                {
                    title: '合同可用额',
                    dataIndex: 'kyAmount',
                    width: 100,
                },
                {
                    title: '质保金',
                    dataIndex: 'guaranteeQuality',
                    width: 100,
                },
                {
                    title: '质保金到期',
                    dataIndex: 'guaranteeQualityDate',
                    width: 100,
                    render: text => text ? new Date(text).format('yyyy-MM-dd') : ''
                }
            ],
            rows: addRows6,
            rowSelection: {
                selectedRowKeys: selectedRowKeys6,
                onChange: this.onSelectChange6,
                onSelect: this.onSelectRadio6,
                type: 'radio',
            }
        };
        return <div>
            <DmsTab options={opts} defaultKey={0}>
                <Button type='primary' onClick={this.submitHandle.bind(this, 'commit')}
                        disabled={this.state.subDisabled}>提交</Button>
                <Button type='primary' onClick={this.submitHandle.bind(this, 'save')}
                        disabled={this.state.subDisabled}>保存</Button>
                <Button onClick={this.goBack}>返回</Button>
            </DmsTab>
            <div className="dms-table-box">
                <Row style={{"height": "35px"}}>
                    < Col span={8}>
                        <p><label>订单日期：</label>
                            <span>{detail.orderDate ? moment(parseInt(detail.orderDate)).format('YYYY-MM-DD') : new Date().format('yyyy-MM-dd')}</span>
                        </p>
                    </Col>
                    <Col span={8}>
                        <p><label>订单编号：</label>
                            <span>{detail.orderNumber || submitParam.orderNumber}</span></p>
                    </Col>
                    <Col span={8}>
                        <p><label>客户名称：</label><span>{this.state.userName}</span></p>
                    </Col>
                </Row>
                <Row style={{"height": "35px"}}>
                    <Col span={8}>
                        <p><label className="ant-form-item-required">购货单位：</label>
                            <Select
                                value={this.state.submitParam.salesUnitId}
                                placeholder="请选择购货单位"
                                style={{minWidth: 250}}
                                onSelect={this.onSelectChangeGouHuoUnit}
                            >
                                {
                                    gouxiaoUnitList.map((item, index) => {
                                        return <Select.Option key={item.value}
                                                              value={item.value}>{item.text}</Select.Option>
                                    })
                                }
                            </Select></p>
                    </Col>
                    <Col span={8}>
                        <p><label>价格单号：</label>
                            <span><Input onClick={this.specialOpen.bind(this)} style={{width: 209}}
                                         value={this.state.submitParam.specialCode}/></span>
                        </p>
                    </Col>
                    <Col span={8}>
                        <p><label>合同/订单名称：</label>
                            <span><Input onClick={this.contractOpen.bind(this)} style={{width: 150}}
                                         value={this.state.contractOrderName}/></span></p>
                    </Col>
                </Row>
                <Row style={{"height": "35px"}}>
                    <Col span={8}>
                        <p><label className="ant-form-item-required">订单类型：</label>
                            <Select
                                value={this.state.submitParam.specialType}
                                placeholder="请选择订单类型"
                                style={{minWidth: 250}}
                                onSelect={this.onSelectChangeSpecialType}
                            >
                                {
                                    specialTypeList.map((item, index) => {
                                        return <Select.Option key={item.value}
                                                              value={item.value}>{item.text}</Select.Option>
                                    })
                                }
                            </Select></p>
                    </Col>
                    <Col span={8}>
                        <p><label>结算对应号：</label>
                            <span><Input style={{width: 150}} value={this.state.settleOrder}
                                         onChange={this.settleOrderChange}/></span></p>
                    </Col>
                    <Col span={8}>
                        <p><label>备注：</label>
                            <span><Input style={{width: 300}} value={this.state.remark}
                                         onChange={this.remarkChange}/></span></p>
                    </Col>
                </Row>
            </div>
            <div>
                <DmsTab className="white-bg no-border" options={['订单物料']} defaultKey={0}/>
                <div className="dms-table-box">
                    <div style={{marginBottom: 8}}>
                        <Button onClick={this.addlist.bind(this)}>选择</Button>
                        <Button style={{marginLeft: 10}} onClick={this.deleteChange.bind(this)}>删除</Button>
                    </div>
                    <TableView {...tableViewProps} />
                    <div className="order_amount" style={{marginTop: 20}}>
                        <p><span className="right">{'总金额：￥' + allAmount}</span></p>
                    </div>
                </div>
            </div>

            <Modal
                visible={visible2}
                title="选择价格单号"
                onCancel={this.handleCancel6}
                maskClosable={false}
                width={1300}
                style={{top: 20}}
                footer={null}
            >
                <div>
                    <section className="section-bordered" style={{marginTop: 0, paddingTop: 5, paddingBottom: 0}}>
                        <Row>
                            <Col span={6}><label>流程编码：</label><Input style={{width: 200}}
                                                                         value={this.state.specCode}
                                                                         onChange={this.specialParam1}/></Col>
                            <Col span={6}><label>项目名称：</label><Input style={{width: 200}}
                                                                         value={this.state.projectName}
                                                                         onChange={this.specialParam2}/></Col>
                            <Col span={6}><label>业务员：</label><Input style={{width: 200}} value={this.state.user}
                                                                       onChange={this.specialParam3}/></Col>
                            <Col span={6}><Button onClick={this.getSepcialList}>搜索</Button></Col>
                        </Row>
                        <TableView {...addProps4} bordered style={{marginTop: 10}}/>
                        <TableView {...addProps5} bordered/>
                    </section>
                    <Row type="flex" justify="center" style={{marginTop: 15}}>
                        <Col>
                            <Button onClick={this.addSaveHandler4}>确认</Button>
                        </Col>
                    </Row>
                </div>
            </Modal>

            <Modal
                visible={visible3}
                title="选择合同"
                // onOk={this.handleOk3}
                onCancel={this.handleCancel5}
                maskClosable={false}
                width={1000}
                style={{top: 20}}
                footer={null}
            >
                <div>
                    <section className="section-bordered" style={{marginTop: 0, paddingTop: 5, paddingBottom: 0}}>
                        <Row>
                            <Col span={8}><label>合同编号：</label><Input style={{width: 200}}
                                                                         value={this.state.contractOrderCode}
                                                                         onChange={this.contractOrderCodeChange}/></Col>
                            <Col span={8}><label>合同名称：</label><Input style={{width: 200}}
                                                                         value={this.state.contractOrderName2}
                                                                         onChange={this.contractOrderNameChange}/></Col>
                            <Col span={8}><Button onClick={this.getContract}>搜索</Button></Col>
                        </Row>
                        <TableView {...addProps6} bordered style={{marginTop: 10}}/>
                    </section>
                    <Row type="flex" justify="center" style={{marginTop: 15}}>
                        <Col>
                            <Button onClick={this.addSaveHandler6}>确认</Button>
                        </Col>
                    </Row>
                </div>
            </Modal>

            <Modal
                visible={visible}
                title="选择物料"
                onOk={this.handleOk.bind(this)}
                onCancel={this.handleCancel.bind(this)}
                maskClosable={false}
                width={800}
            >
                <section className="section-bordered" style={{marginTop: 0, paddingTop: 5, paddingBottom: 0}}>
                    <Row>
                        <Col span={14}><label>物料名称/编码：</label><Input style={{width: 250}}
                                                                           value={this.state.addSearchObj.productCode}
                                                                           onChange={this.nameChange.bind(this)}
                                                                           onKeyPress={this.keypress}/></Col>
                        <Col span={4}><Button onClick={this.addlist.bind(this)}>搜索</Button></Col>
                    </Row>
                    <div>
                        <TableView {...addProps} bordered style={{marginTop: 10}}/>
                    </div>
                </section>
            </Modal>

        </div>
    }
}
;
export default withRouter(SpecialOrderAdd);


// WEBPACK FOOTER //
// ./src/routes/specialOrder/add.js